import BalanceModule from './BalanceModule'
import AudioControlsModule from './AudioControlsModule'
import BurgerMenuModule from './BurgerMenuModule'
import ChatModule from './ChatModule'
import JackpotBarModule from './JackpotBarModule'

const Header = () => {
  return (
    <div className="standard-normal-game-header-outer-container">
      <div className="standard-normal-game-header-inner-container">
        <div className="standard-normal-game-header-left-container">
          <BalanceModule />
        </div>
        <div className="standard-normal-game-header-right-container">
          <JackpotBarModule />
          <ChatModule />
          <AudioControlsModule />
          <BurgerMenuModule />
        </div>
      </div>
    </div>
  )
}

export default Header
